import { render, staticRenderFns } from "./GlobalTagManagement.vue?vue&type=template&id=01ed0b37&scoped=true"
import script from "./GlobalTagManagement.vue?vue&type=script&lang=js"
export * from "./GlobalTagManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ed0b37",
  null
  
)

export default component.exports